// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"equipments_routeHeader_3fKwT","addButton":"equipments_addButton_3KF0d"};